/* eslint-disable react/prop-types */
import classes from "./correlated-area.module.scss";

import classNames from "classnames";
import Flex from "@/components-library/layout/flex";
import Label from "@/components-library/widgets/label";
import Grid from "@/components-library/layout/grid";
import DatePicker, { registerLocale } from "react-datepicker";
import it from "date-fns/locale/it";
import "react-datepicker/dist/react-datepicker.css";
import SelectableList from "@/components-library/widgets/selectable-list";
function CorrelatedArea({
  announcements,
  selectedAnnouncements,
  onAnnouncementSelect,
  services,
  selectedServices,
  onServiceSelect,
  isCorrelatedAnnouncementsValid,
  isCorrelatedServicesValid,
  isCorrelationExpireValid,
  correlationExpire,
  onCorrelationExpireDateChange,
}) {
  registerLocale("it", it);
  return (
    <Flex
      align="flex-start"
      direction="column"
      justify="center"
      className={classes.infoContainer}
    >
      <Label
        tag="h6"
        weight="bold"
        color="secondary"
        align="start"
        className={classes.subTitle}
      >
        Correlazioni
      </Label>
      <Grid columns="1fr 1fr 1fr">
        <SelectableList
          title="Bandi correlati"
          list={announcements}
          value={selectedAnnouncements}
          onItemSelect={onAnnouncementSelect}
          isEnabled={true}
          isMultiSelect={true}
          className={classes.list}
          headerClassName={classNames(classes.headerList, {
            [classes.valid]: isCorrelatedAnnouncementsValid,
          })}
          titleClassName={classes.titleList}
        />
        <SelectableList
          title="Servizi correlati"
          list={services}
          value={selectedServices}
          onItemSelect={onServiceSelect}
          isEnabled={true}
          isMultiSelect={true}
          className={classes.list}
          headerClassName={classNames(classes.headerList, {
            [classes.valid]: isCorrelatedServicesValid,
          })}
          titleClassName={classes.titleList}
        />
        <Flex
          align="flex-start"
          direction="column"
          justify="flex-start"
          className={classNames(classes.dateArea, {
            [classes.valid]: isCorrelationExpireValid,
          })}
        >
          <Label tag="p" size="md" align="start" color="secondary">
            Data termine cumulabilità
          </Label>
          <DatePicker
            locale="it"
            selected={correlationExpire}
            onChange={(date) => onCorrelationExpireDateChange(date)}
            wrapperClassName="datePicker"
            dateFormat={"dd/MM/yyyy"}
          />
        </Flex>
      </Grid>
    </Flex>
  );
}

export default CorrelatedArea;
